"use strict";function getPhoneInfo$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.getPhoneInfo$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.base.getPhoneInfo";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"3.5.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"3.5.0"},_a)),exports.getPhoneInfo$=getPhoneInfo$,exports.default=getPhoneInfo$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/base/getPhoneInfo.js
// module id = 1052
// module chunks = 106